export const States = {
	NSW: 'NSW',
	VIC: 'VIC',
	QLD: 'QLD',
	SA: 'SA',
	WA: 'WA',
	ACT: 'ACT',
	NT: 'NT',
	TAS: 'TAS'
};
